/**Import statements for Page Loader Component
 * @created 07/05/2022
 */

import { MotifProgressBar } from '@ey-xd/motif-react';
import { useEffect } from 'react';
import './index.scss';
/** Import statements end here */

const PageLoader = (props: any) => {
  const { isLoading } = props;

  // disabling scrollbar while the page is on loading
  useEffect(() => {
    document.body.style.overflowY = props.isLoading ? 'hidden' : 'auto';
  }, [props.isLoading]);

  // Actual search box component rendered over here
  return isLoading ? (
    <div className="loader-container">
      <MotifProgressBar circle isIndeterminate hideLabel className="loader" />
    </div>
  ) : null;
};
export { PageLoader };
